export const buildUnitySaveAttemptId = (reason = "unspecified"): string => {
  const normalizedReason = reason
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "") || "unspecified";
  const randomPart =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);
  return `save_${normalizedReason}_${Date.now()}_${randomPart}`;
};
